// extracted by mini-css-extract-plugin
module.exports = {"box":"role_box_1F4Eq","info":"role_info_2l-Rr","sure":"role_sure_2rx5n"};